import { GISService } from './gisServicesTypes';

/**
 * Check whether a service is authoritative — the PSAP's own system-of-record
 * GIS, as opposed to a supplemental overlay.
 *
 * Historically this was inferred from the URL, because the only authoritative
 * sources we saw were GeoComm and NENA EPRC. Admins can now mark any service
 * authoritative in Andromeda, so the URL check is kept only as a fallback for
 * services configured before that flag existed.
 *
 * Authoritative services are treated as essential rather than optional:
 * they load immediately, their tokens are registered with ESRI's
 * IdentityManager for on-demand loading, they render at full opacity, they
 * appear under the ECC-specific layer tab, and they are never hidden during
 * pan/zoom.
 */
export function isAuthoritative(service: GISService | undefined): boolean {
  if (!service) return false;
  const url = service.gis_service_url?.toLowerCase() || '';
  return (
    url.includes('geocomm') ||
    url.includes('nenaeprc') ||
    !!service.attributes?.authoritative
  );
}
